import { handleActions } from 'redux-actions'

import log from 'utils/logger'

const initialState = {
  all: [],
  by_id: {}
}

const airQualities = handleActions({
  GET_ALL_AIR_QUALITY_FULFILLED(state, { payload }) {
    return Object.assign({}, state, {all: payload})
  },

  GET_AIR_QUALITY_FULFILLED(state, { payload }) {
    const nextStore = Object.assign({}, state.by_id)
    nextStore[payload.id] = payload
    return Object.assign({}, state, {by_id: nextStore})
  },

  CREATE_AIR_QUALITY_FULFILLED(state, { payload }) {
    log("created air quality record", payload)
    return Object.assign({}, state, {all: state.all.concat(payload)})
  },

  CREATE_AIR_QUALITY_FAILED(state, { payload }) {
    log("failed to create air quality record", payload)
    return state
  },

  DELETE_AIR_QUALITY_FULFILLED(state, { payload }) {
    let nextStore = state.all.map(airQuality => {
      if (airQuality.id === payload.id) return null
      else return airQuality
    }).filter(record => record !== null)

    return Object.assign({}, state, {all: nextStore})
  },
}, initialState)


export default airQualities

const AirQualitySelectors = {
  all(state) {
    return state.airQualities.all || []
  },

  get(state, id) {
    return state.airQualities.by_id[id]
  }
}

export { AirQualitySelectors }